const rules = [
    'Full playthrough - start to finish, no intro or outro',
    '720p or higher',
    "The level's main path",
    'No LDM',
    'No click sounds',
    'No shaders, filters or overlays',
    "No texture packs that change the level's look",
    "The level's NONG song, if it has one",
];

export default function ShowcaseRules() {
    return (
        <ul className='mt-1 list-disc ps-5 text-sm'>
            {rules.map((rule) => (
                <li key={rule}>{rule}</li>
            ))}
        </ul>
    );
}
